import { getApiUrlTemplateFunc } from '../../../helpers/getApiUrlTemplateFunc'
import API from '../../../services/api'
import { abbreviationsAPIMessages } from './configs'
import { alertError, alertSuccess } from '../../../api'
import { SourceTypeMap, SourceTypes } from 'tabs/nlp/constants'
import { TextInsertPayload } from 'tabs/nlp/components/KnowledgeBaseReplies/EditKnowledgeBaseReply'

const template = getApiUrlTemplateFunc('knowledge')

const getKnowledgeSources = (type: SourceTypes) => {
  return API.get(template('', { type }))
}

const deleteKnowledgeSource = async (type: SourceTypes, id: string): Promise<any> => {
  return API.delete(template(`${id}`, { type })).then(response => {
    alertSuccess(abbreviationsAPIMessages.deleted)
    return response
  })
}

const addWebsiteKnowledgeSources = (body: {
  url: string
  type: SourceTypes
}): Promise<{ id: string; type: SourceTypes; url: string } | undefined | null> => {
  return API.post(template('', { type: SourceTypeMap.WEBSITE }), body)
}

const downloadKnowledgeFile = async (id: string, body: any): Promise<Blob> => {
  try {
    return await API.binaryPost(template(`${id}/download`), body)
  } catch (error) {
    alertError('Error during downloading')
  }
}

const train = async (type: SourceTypes, body: string[]): Promise<any> => {
  return API.post(template('train', { type }), body)
}

const createTextKnowledgeSources = (body: { title: string; text: string; replyId?: number; type: SourceTypes }) => {
  return API.post(template('', { type: SourceTypeMap.TEXT }), body)
}

const updateTextKnowledgeSources = (
  body: TextInsertPayload & {
    _id: string
  },
) => {
  return API.put(template('', { type: SourceTypeMap.TEXT }), body)
}

export const knowledgeService = {
  deleteKnowledgeSource,
  addWebsiteKnowledgeSources,
  downloadKnowledgeFile,
  train,
  getKnowledgeSources,
  createTextKnowledgeSources,
  updateTextKnowledgeSources,
}
